import type { CrystallizeImage } from "#shared/types/crystallize";
import type { Crystallize } from "#shared/utils/crystallize-spec";

export const SINGLE_PRODUCT_TEMPLATES = [
  "standard",
  "pluss",
  "grunnskole",
] as const satisfies ReadonlyArray<Crystallize.SingleProductTemplate>;

export const SINGLE_PRODUCT_THEMES = [
  "green",
  "blue",
  "purple",
] as const satisfies ReadonlyArray<Crystallize.SingleProductColorTheme>;

export interface SingleProduct
  extends Product<"single-product", SingleProductVariant> {
  template: Crystallize.SingleProductTemplate;
  theme: Crystallize.SingleProductColorTheme;
  biblioFormats: BiblioFormat[];
  intro?: string;
  description?: string;
  heroCards?: HeroCards;
  selfDefinedColorVariant?: boolean;
  footerMascot?: string;
  illustration?: CrystallizeImage;
  relatedProducts: Packet[];
  pendelCta: boolean;
  levelFilter?: LevelFilter;
}

export const LANGUAGES = ["nob", "nno", "eng", "ger", "no2"] as const;

export type Language = (typeof LANGUAGES)[number];

export interface SingleProductVariant extends ProductVariant<"single-product"> {
  isPurchasable: boolean;
  intro?: string;
  authors?: string;
  release?: Date;
  pages?: string;
  textColor?: string;
  mainColor?: string;
  languages?: Language[];
  browsableLink?: string;
  previewLink?: string;
}

export interface HeroCardContent {
  text?: string;
  backgroundColor?: string;
  textColor?: string;
}

export interface HeroCards {
  content: HeroCardContent[];
  mascotImages: CrystallizeImage[];
  colorTheme: string;
}
